export enum MenuEnum {

}

export enum PermissionEnum {
    Access = 'access',
    Update = 'update',
    Create = 'create',
    Delete = 'delete',
}